import { create } from 'zustand'

interface GlobalLoadingState {
  /** Named locks so overlapping requests don't flicker the overlay */
  locks: Record<string, boolean>
  isLoading: boolean
  start: (key?: string) => void
  stop: (key?: string) => void
  reset: () => void
}

function compute(locks: Record<string, boolean>) {
  return Object.values(locks).some(Boolean)
}

/** Global loading overlay state — use sparingly for full-page waits. */
export const useLoadingStore = create<GlobalLoadingState>((set, get) => ({
  locks: {},
  isLoading: false,

  start: (key = 'default') => {
    const locks = { ...get().locks, [key]: true }
    set({ locks, isLoading: compute(locks) })
  },

  stop: (key = 'default') => {
    const locks = { ...get().locks }
    delete locks[key]
    set({ locks, isLoading: compute(locks) })
  },

  reset: () => set({ locks: {}, isLoading: false }),
}))
